import React, { forwardRef } from "react";
import { useDraggable, useDroppable } from "@dnd-kit/core";

export const FileDragItem = props => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: props.id,
    disabled: props.disabled,
    data: props.value
  });

  return (
    <FileDisplayItem ref={setNodeRef} {...listeners} {...attributes}>
      {props.children}
    </FileDisplayItem>
  );
};

export const FolderDropItem = props => {
  const { attributes, listeners, setNodeRef, isOver } = useDroppable({
    id: props.id,
    disabled: props.disabled,
    data: props.value
  });

  return (
    <FolderDisplayItem ref={setNodeRef} {...listeners} {...attributes}>
      {typeof props.children === "function" ? props.children(isOver) : props.children}
    </FolderDisplayItem>
  );
};

export const FileDisplayItem = forwardRef(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref}>
      {children}
    </div>
  );
});

export const FolderDisplayItem = forwardRef(({ children, ...props }, ref) => {
  return (
    <div {...props} ref={ref}>
      {children}
    </div>
  );
});
